import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

/** Toggles password visibility without persisting it beyond this component instance. */
@Component({
  selector: 'app-password-toggle',
  templateUrl: './password-toggle.component.html',
  styleUrls: ['./password-toggle.component.scss'],
  imports: [FaIconComponent]
})
export class PasswordToggleComponent implements OnInit {
  @Input({ required: true }) field: HTMLInputElement;
  visible = false;
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    // Mask on submit so browsers never record a revealed password as plain form text.
    const form = this.field.form;
    if (form) {
      const mask = () => this.setVisible(false);
      form.addEventListener('submit', mask);
      this.destroyRef.onDestroy(() => form.removeEventListener('submit', mask));
    }
  }

  toggle() {
    this.setVisible(!this.visible);
  }

  private setVisible(visible: boolean) {
    this.visible = visible;
    this.field.type = visible ? 'text' : 'password';
  }
}
